import React, { Component } from 'react';
import Dialog from '../../../../commonModules/interface/Dialog';
import Pagination from '../../../../commonModules/interface/Pagination';
import Spin from '../../../../commonModules/interface/Spin.jsx';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, TableHead, TableBody, Card, Grid, Box, FormControlLabel, FormGroup, Switch, AppBar, Tabs, Tab } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import { SearchRounded, AddShoppingCartRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import InputText, { InputSelect, InputSelectNative } from '../../../../commonModules/interface/form-input-inline.jsx';
import Currency from '../../../../commonModules/Currency';
import AdoptProductDialog from './AdoptProductDialog';

// Libellés des types de produit. Hissés hors du composant parce que la liste du
// catalogue s'en sert aussi : le serveur y renvoie la clé brute, et deux
// tableaux qui nomment différemment le même type se liraient mal.
const TYPES_PRODUIT = {
    "panneaux":"Panneaux Solaires",
    "regulateurs":"Régulateurs",
    "convertisseurs":"Convertisseurs",
    "convertisseurs_chargeurs":"Convertisseur-Chargeurs",
    "convertisseurs_chargeurs_MPPT":"Convertisseur-Chargeurs - MPPT",
    "convertisseurs_dc-dc":"Convertisseur DC-DC",
    "batteries":"Batteries",
    "cables":"Câbles",
    "lampes":"Lampes",
    "supervision":"Supervision",
    "kit":"Kits complet",
    "menager":"Equipement ménager",
    "pompes":"Pompes",
    "picos":"Picos",
    "accesoires":"Accessoires",
    "protection":"Protection",
    "autres":"Autres",
    "equipement_bt":"Equipement BT"
}

class ListProduct extends Component {
    state = {
        single:{
            id:"",
            name: "",
        },
        dialogStock: false,
        filteredList: Object.keys(this.props.PRODUCTS),
        search:{
            searchName: "",
            searchMarque: "",
            searchType: "",
            searchRef: "",
            inStock: false
        },

        // « Mes produits » reste le mode par défaut : l'écran est d'abord la
        // liste de travail du compte. Le catalogue est un détour volontaire.
        mode: "mine",
        catalogueSearch:{
            searchName: "",
            searchMarque: "",
            searchRef: "",
        },
        cataloguePage: 0,
        catalogueRowsPerPage: 20,
        adoptProduct: null,
    }

    componentDidUpdate(prevProps) {
        // filteredList est un instantané de PRODUCTS pris au montage. Après une
        // adoption, la liste du compte est relue et le store change : sans cette
        // réapplication des filtres, le produit tout juste ajouté n'apparaîtrait
        // qu'au premier caractère tapé dans la recherche.
        if (prevProps.PRODUCTS !== this.props.PRODUCTS) {
            this.filterList()
        }
    }

    filterList = (search = this.state.search) => {
        const { searchName, searchMarque, searchType, searchRef, inStock } = search;

        const { PRODUCTS, AVAILABLE } = this.props
        let filteredList = Object.keys(PRODUCTS)

        const vName = (searchName).toLowerCase()
        const vMarque = (searchMarque).toLowerCase()
        const vType = (searchType).toLowerCase()
        const vRef = (searchRef).toLowerCase()

        if (!isEmpty(searchName) ){
            filteredList = filteredList.filter( prodID => (
                    PRODUCTS[prodID] && PRODUCTS[prodID].name.toLowerCase().includes(vName)
                )
            )
        }
        if (!isEmpty(searchMarque) ){
            filteredList = filteredList.filter( prodID => (
                    PRODUCTS[prodID] && PRODUCTS[prodID].marque.toLowerCase().includes(vMarque)
                )
            )
        }
        if (!isEmpty(searchType) ){
            filteredList = filteredList.filter( prodID => (
                    PRODUCTS[prodID] && PRODUCTS[prodID].product_type === vType
                )
            )
        }
        if (!isEmpty(searchRef) ){
            filteredList = filteredList.filter( prodID => (
                    PRODUCTS[prodID] && PRODUCTS[prodID].ref.toLowerCase().includes(vRef)
                )
            )
        }
        if (inStock) {
            filteredList = filteredList.filter( prodID => {
                let list = Object.values(AVAILABLE).filter( stock => stock.product_id === prodID && stock.quantity > 0)
                return list.length > 0
            })
        }

        filteredList.sort((a, b) => (a.is_disabled === b.is_disabled) ? 0 : a.is_disabled ? 1 : -1);
        this.setState({
            filteredList
        })
        // return filteredList
    }

    // FORM MANAGER ...
        handleSearch = (e) => {
            const { name, value } = e.target
            let newSearch = Object.assign({}, this.state.search)
            newSearch[name] = value

            this.setState({
                ...this.state,
                search: newSearch,
            })
            this.filterList(newSearch)
        }
        handleChecked = (e) => {
            const { name, checked } = e.target
            let newSearch = Object.assign({}, this.state.search)
            newSearch[name] = checked

            this.setState({
                ...this.state,
                search: newSearch,
            })
            this.filterList(newSearch)
        }

        createTypeList = () => {
            return Object.keys(TYPES_PRODUIT).map((key) => {
                return (
                    <option key={key} value={key} >{TYPES_PRODUIT[key]}</option>
                )
            })
        }

    // BASCULE MES PRODUITS / CATALOGUE ...
        handleMode = (e, mode) => {
            this.setState({ mode })

            // Le catalogue compte des milliers d'entrées : il n'est demandé au
            // serveur que si l'utilisateur va le voir, et une seule fois.
            const { CATALOGUE } = this.props
            if (mode === "catalogue" && CATALOGUE && !CATALOGUE.loaded && !CATALOGUE.loading) {
                this.props.fetchCatalogue()
            }
        }

        handleCatalogueSearch = (e) => {
            const { name, value } = e.target
            let newSearch = Object.assign({}, this.state.catalogueSearch)
            newSearch[name] = value

            // Retour à la première page : sur près de quatre mille produits, un
            // filtre posé depuis la page 30 ne laisserait sinon rien à afficher.
            this.setState({
                catalogueSearch: newSearch,
                cataloguePage: 0,
            })
        }

        onChangeCataloguePage = (pageOfItems, currentPage, rowsPerPage) => {
            // Le pied de tableau revient de lui-même à la première page quand on
            // change le nombre de lignes, tout en annonçant encore l'ancienne :
            // suivre ce qu'il affiche évite de montrer une page vide.
            const changementDeTaille = rowsPerPage !== this.state.catalogueRowsPerPage
            this.setState({
                cataloguePage: changementDeTaille ? 0 : currentPage,
                catalogueRowsPerPage: rowsPerPage,
            })
        }

        // Un produit déjà chez soi reste visible mais non actionnable : le
        // chercher une seconde fois pour découvrir qu'on l'a déjà est une perte
        // de temps. Deux sources répondent à la question, et la seconde couvre
        // la première : le serveur au chargement du catalogue, puis la liste des
        // produits du compte, relue après chaque adoption.
        estAdopte = (produit) => {
            const { PRODUCTS } = this.props
            return !!produit.deja_adopte || !!(PRODUCTS && PRODUCTS[produit.id])
        }

        filterCatalogue = () => {
            const { CATALOGUE } = this.props
            const produits = (CATALOGUE && CATALOGUE.produits) || []
            const { searchName, searchMarque, searchRef } = this.state.catalogueSearch

            const vName = searchName.toLowerCase()
            const vMarque = searchMarque.toLowerCase()
            const vRef = searchRef.toLowerCase()

            return produits.filter( produit => {
                if (!isEmpty(searchName) && !(produit.name || "").toLowerCase().includes(vName)) {
                    return false
                }
                if (!isEmpty(searchMarque) && !(produit.marque || "").toLowerCase().includes(vMarque)) {
                    return false
                }
                if (!isEmpty(searchRef) && !(produit.ref || "").toLowerCase().includes(vRef)) {
                    return false
                }
                return true
            })
        }

    // ADOPTION ...
        openAdopt = (produit) => {
            this.setState({ adoptProduct: produit })
        }

        closeAdopt = () => {
            this.setState({ adoptProduct: null })
        }

    createProductList = () => { // table
        const { PRODUCTS, rowsPerPage, currentPage, AVAILABLE } = this.props
        // return this.props.pageOfItems.map( ID => (
        return this.state.filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((ID) => {
            let available = Object.values(AVAILABLE).filter( stock => stock.product_id === ID && stock.quantity > 0)
            let total =  0
            if (!isEmpty(available) ) {
                available.forEach( stock => total += stock.quantity)
            }

            // console.log({available, total});
            return (
            <TableRow
                key={ID}
                style={{
                    textDecoration: PRODUCTS[ID].is_disabled ? "line-through" : undefined,
                    color: PRODUCTS[ID].is_disabled ? "grey" : undefined,
                    fontStyle: PRODUCTS[ID].is_disabled ? "italic" : undefined,
                    textDecorationThickness: PRODUCTS[ID].is_disabled ? "2px" : "auto"
                }}
            >
                <TableCell>
                    <Button
                        startIcon={<SearchRounded />}
                        color="secondary"
                        variant="contained"
                        style={{width: "100%"}}
                        onClick={ () => this.setState({
                            dialogStock:true,
                            single:{
                                id: PRODUCTS[ID].id,
                                name: PRODUCTS[ID].name
                                }
                            })
                        }
                    >
                        {total}
                    </Button>
                </TableCell>
                <TableCell>{PRODUCTS[ID].ref}</TableCell>
                {PRODUCTS[ID].photos && PRODUCTS[ID].photos.length > 0 && PRODUCTS[ID].photos[0].filename &&
                    <TableCell className="lightbox-item p-item">
                        <img
                            id={PRODUCTS[ID].photos[0].filename}
                            src={`/stocks/photos/${PRODUCTS[ID].photos[0].filename}`}
                            style={{width:"100px", height:"auto"}}
                        />
                        {/* <img id={PRODUCTS[ID].photos[0].filename} src={PRODUCTS[ID].mainPhoto} style={{width:"100px", height:"auto"}}/> */}
                    </TableCell>
                }
                {(!PRODUCTS[ID].photos || PRODUCTS[ID].photos.length === 0 || !PRODUCTS[ID].photos[0] || !PRODUCTS[ID].photos[0].filename) &&
                    <TableCell className="lightbox-item p-item">
                        <img src="img/noImg.png" alt="" style={{width:"100px", height:"auto"}}/>
                    </TableCell>
                }
                <TableCell><a href="#" onClick={ () => this.props.handleSingle(PRODUCTS[ID]) }> {PRODUCTS[ID].name}</a></TableCell>
                <TableCell>{PRODUCTS[ID].marque}</TableCell>
                <TableCell><Currency value={PRODUCTS[ID].prix_venteHT} /></TableCell>
                <TableCell><Currency value={PRODUCTS[ID].prix_venteTTC} /></TableCell>
            </TableRow>
        )})
    }

    createCatalogueList = (produits) => { // table
        const { cataloguePage, catalogueRowsPerPage } = this.state
        const debut = cataloguePage * catalogueRowsPerPage

        // Seule la page affichée est rendue : le catalogue entier compte des
        // milliers de lignes, en poser autant dans le DOM figerait l'écran.
        return produits.slice(debut, debut + catalogueRowsPerPage).map((produit) => {
            const adopte = this.estAdopte(produit)

            return (
                <TableRow
                    key={produit.id}
                    style={{
                        color: adopte ? "grey" : undefined,
                        fontStyle: adopte ? "italic" : undefined,
                    }}
                >
                    <TableCell>{produit.ref}</TableCell>
                    <TableCell>{produit.name}</TableCell>
                    <TableCell>{produit.marque}</TableCell>
                    <TableCell>{TYPES_PRODUIT[produit.product_type] || produit.product_type}</TableCell>
                    <TableCell>
                        {adopte &&
                            <span>Déjà dans mes produits</span>
                        }
                        {!adopte &&
                            <Button
                                startIcon={<AddShoppingCartRounded />}
                                color="secondary"
                                variant="contained"
                                size="small"
                                onClick={() => this.openAdopt(produit)}
                            >
                                Ajouter
                            </Button>
                        }
                    </TableCell>
                </TableRow>
            )
        })
    }

    findStocks = () => {// find shops with stocks of this product
        let found = false;
        const { AVAILABLE, SHOPS } = this.props
        if(AVAILABLE){
            return[
                Object.values(AVAILABLE).filter(
                    stock => stock.product_id === this.state.single.id && stock.quantity > 0).map(
                        stock => {
                        found = true
                        return (
                            <TableRow key={stock.id}>
                                <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                                <TableCell>{SHOPS[stock.shop_id].city}</TableCell>
                                <TableCell>{stock.quantity}</TableCell>
                                {/* <TableCell>{stock.prix_revient}</TableCell> */}
                            </TableRow>
                        )
                }),
                found
            ]
        } else {
            return ["",false]
        }
    }


    render() {
        console.log("[STATE] List Products ",this.state);

        const { filteredList, mode, adoptProduct } = this.state
        const { CATALOGUE } = this.props
        console.log({filteredList});

        const catalogue = mode === "catalogue" ? this.filterCatalogue() : []

        const stockTable = (
            this.state.dialogStock === true &&
            <div>
                {this.findStocks()[1] &&
                    // <div className="table-responsive">
                    //     <table id="data-table-selection" className="table text-left">
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Shop</TableCell>
                                <TableCell>Ville</TableCell>
                                <TableCell>Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.findStocks()[0]}
                        </TableBody>

                    </TableLayout>
                    //     </table>
                    // </div>
                }
                {!this.findStocks()[1] &&
                    <div>
                        <span>Pas de stock disponible</span>
                        {/* <button className="btn btn-xs btn-primary" >
                            Nouveau stock
                        </button> */}
                    </div>
                }
            </div>
        )

        return (
            <React.Fragment>
                {this.state.dialogStock &&
                    <Dialog
                        block={this.state.dialogStock}
                        title={this.state.single.name}
                        text={ stockTable }
                        close={() => this.setState({
                            dialogStock:false,
                            single:{
                                id: "",
                                name: ""
                                }
                            })

                        }
                    />
                }
                {adoptProduct &&
                    <AdoptProductDialog
                        produit={adoptProduct}
                        adoptCatalogueProduct={this.props.adoptCatalogueProduct}
                        close={this.closeAdopt}
                        onAdopted={this.closeAdopt}
                    />
                }
                <AppBar position="static">
                    <Tabs
                        value={mode}
                        onChange={this.handleMode}
                        indicatorColor="secondary"
                        variant="fullWidth"
                    >
                        <Tab value="mine" label="Mes produits" />
                        <Tab value="catalogue" label="Catalogue" />
                    </Tabs>
                </AppBar>

                {mode === "mine" &&
                <React.Fragment>
                <Card title="Recherche">
                    <Box p={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchRef" onChange={this.handleSearch} value={this.state.search.searchRef} name="searchRef" title="Reference du produit"/>

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchName" onChange={this.handleSearch} value={this.state.search.searchName} name="searchName" title="Nom du produit"/>

                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchMarque" onChange={this.handleSearch} value={this.state.search.searchMarque} name="searchMarque" title="Marque du produit"/>

                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <InputSelectNative
                                    id="searchType"
                                    onChange={this.handleSearch}
                                    value={this.state.search.searchType}
                                    name="searchType"
                                    title="Type"
                                    options={this.createTypeList()}
                                    labelWidth={60}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.state.search.inStock}
                                                onChange={this.handleChecked}
                                                name="inStock"
                                                color="secondary"
                                            />
                                        }
                                        label="Produits en stock seulement"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                </Card>
                {!isEmpty(filteredList) &&
                    <TableLayout>
                        <TableHead>
                            <TableRow style={{ textAlign: "center"}}>
                                <TableCell component="th">En Stock</TableCell>
                                <TableCell component="th">Réference</TableCell>
                                <TableCell component="th">Photo</TableCell>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell component="th">Marque</TableCell>
                                <TableCell component="th">Prix HT</TableCell>
                                <TableCell component="th">Prix TTC</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createProductList()}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={6}
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                        />
                    </TableLayout>

                }

                {isEmpty(filteredList) &&
                    <div className="text-center">
                        <h5>Pas de produit</h5>
                        cliquez sur
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={ this.props.handleNew}
                        >
                            Nouveau
                        </Button> pour entrer un nouveau produit
                    </div>
                }
                </React.Fragment>
                }

                {mode === "catalogue" &&
                <React.Fragment>
                <Card title="Recherche">
                    <Box p={2}>
                        <Box p={1}>
                            <span>
                                Le catalogue rassemble les fiches produit de la plateforme. Ajouter
                                l'une d'elles à votre compte revient à lui donner votre prix : la
                                fiche, elle, reste commune.
                            </span>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueRef" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchRef} name="searchRef" title="Reference du produit"/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueName" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchName} name="searchName" title="Nom du produit"/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueMarque" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchMarque} name="searchMarque" title="Marque du produit"/>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>

                {CATALOGUE && CATALOGUE.loading && <Spin noOverlay />}

                {CATALOGUE && CATALOGUE.error &&
                    <div className="text-center">
                        <h5>{CATALOGUE.error}</h5>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.fetchCatalogue()}
                        >
                            Réessayer
                        </Button>
                    </div>
                }

                {!isEmpty(catalogue) &&
                    <TableLayout>
                        <TableHead>
                            <TableRow style={{ textAlign: "center"}}>
                                <TableCell component="th">Réference</TableCell>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell component="th">Marque</TableCell>
                                <TableCell component="th">Type</TableCell>
                                <TableCell component="th">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createCatalogueList(catalogue)}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={5}
                            items={catalogue}
                            onChangePage={this.onChangeCataloguePage}
                            initialPage={this.state.cataloguePage}
                        />
                    </TableLayout>
                }

                {isEmpty(catalogue) && CATALOGUE && CATALOGUE.loaded && !CATALOGUE.error &&
                    <div className="text-center">
                        <h5>Aucun produit du catalogue ne correspond à cette recherche</h5>
                    </div>
                }
                </React.Fragment>
                }

                {/* <div className="text-center">
                    {this.props.reloadPagination && // force Pagination Update
                        <Pagination
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                            pageSize={15}
                        />
                    }
                    {!this.props.reloadPagination &&
                        <Pagination
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                            pageSize={15}
                        />
                    }
                </div> */}

            </React.Fragment>

        );
    }
}

export default ListProduct;
